import React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { useDrop } from 'react-dnd';
import Charts from '../../containers/Engineering/Charts';
import Unity from '../../containers/Unity';

import './GraphicsArea.sass';

const GraphicsArea = ({ moveChart, visible }) => {
  let classes = 'graphics-area';
  if (!visible) {
    classes += ' offscreen';
  }

  const [, drop] = useDrop({
    accept: 'CHART',
    drop: (item, monitor) => {
      const delta = monitor.getDifferenceFromInitialOffset();

      const left = Math.round(item.left + delta.x);
      const top = Math.round(item.top + delta.y);

      moveChart(item.id, left, top);
    },
  });

  return (
    <div className={classes} style={{ order: 10 }} role="region" aria-label="Interactive graphics and simulation">
      <ReactResizeDetector handleWidth handleHeight>
        {({ width, height }) => (
          <div ref={drop} className="draggables">
            <div>
              <Charts dims={[width, height]} />
            </div>
            <Unity />
          </div>
        )}
      </ReactResizeDetector>
    </div>
  );
};

export default GraphicsArea;
